import React, { Component } from "react";
import { Field } from "redux-form";
import { get, find } from "lodash";
import cx from "classnames";
import { FormattedMessage } from "react-intl";
import { getClassName } from "../../ui-kit/utils/component";
import { Select } from "../../ui-kit/components";

import "./CurrencySelector.scss";

import icon1 from "./img/dollar.png";
import icon2 from "./img/bitcoin.png";

const ccn = getClassName("currency-selector");

const options = [
  { value: "USD", label: "USD" },
  { value: "EUR", label: "EUR" }
];

class CurrencySelector extends Component {
  constructor(props, ...args) {
    super(props, args);

    this.currency = props.currency;
  }

  onChange = (e) => {
    const value = get(e, "value", null);
    if (value) {
      this.currency = value;
      this.props.onChange(value);
    }
  };

  onRadioChange = ({ target }) => {
    let { currency } = this;
    if (target.value === "bitcoin") {
      currency = "BTC";
    } else if (currency === "BTC") {
      currency = "USD";
    }

    this.props.onChange(currency);
  };

  render() {
    const {
      currency,
      dataForFormattedMessage
    } = this.props;

    const selectValue = find(options, { value: currency });

    return (
      <div className={ccn()}>
        <Field
          component="input"
          type="radio"
          name="invest_type"
          onChange={this.onRadioChange}
          value="money"
          checked={currency !== "BTC"}
          id="money"
        />
        <label htmlFor="money" className={ccn("card")}>
          <div className={ccn("icon")}>
            <img src={icon1} alt="icon" data-defcur="USD" />
          </div>
          <div className={ccn("text")}>
            <div className={ccn("title")}>
              <FormattedMessage
                id={dataForFormattedMessage.id}
                defaultMessage={dataForFormattedMessage.default}
              />
            </div>
            <div className={cx(ccn("header"), ccn("header_select"))}>
              <Field
                component={Select}
                name="money_currency"
                options={options}
                className="Select"
                onChange={this.onChange}
                isSearchable={false}
                val={selectValue}
                onInputChange={this.onChange}
                selectedValue={selectValue}
                defaultValue={options[0]}
              />
            </div>
          </div>
        </label>
        <Field
          component="input"
          type="hidden"
          name="currency"
          value={currency}
        />
        <Field
          component="input"
          type="radio"
          name="invest_type"
          onChange={this.onRadioChange}
          value="bitcoin"
          checked={currency === "BTC"}
          id="bitcoin"
        />
        <label htmlFor="bitcoin" className={ccn("card")}>
          <div className={ccn("icon")}>
            <img src={icon2} alt="icon" data-defcur="BTC" />
          </div>
          <div className={ccn("text")}>
            <div className={ccn("title")}>
              <FormattedMessage
                id="hbc.invest.crypto.title"
                defaultMessage="Crypto"
              />
            </div>
            <div className={ccn("header")}>BTC</div>
          </div>
        </label>
      </div>
    );
  }
}

export default CurrencySelector;



// WEBPACK FOOTER //
// ./src/components/currencySelector/CurrencySelector.js